import { expect } from 'bun:test';
import * as fakedom from './fakedom';
export * as fakedom from './fakedom';

// Fakedom must be imported first, as it sets up the global environment.
import A from "aberdeen";

function toDisplay(value: any) {
	if (value instanceof Map) {
		let results: string[] = []
		value.forEach((value,key) => results.push(JSON.stringify(key)+": "+JSON.stringify(value)))
		return "map{" + results.join(", ") + "}"
	} else {
		return JSON.stringify(value)
	}
}

export class AssertError extends Error {
	constructor(text: string, actual: any, expected: any, expectLiteral: boolean = false) {
		text += `
		Actual:   ${toDisplay(actual)}
		Expected: ${expectLiteral ? expected : toDisplay(expected)}`
		super(text)
	}
}

export function assert(bool: any, msg?: string): void {
	if (!bool) throw new AssertError(`assert failed${msg ? ": "+msg : ""}`, bool, "something trueish", true)
}

export function assertContains(actual: any, expected: {indexOf: (v: any)=>number}, msg?: string): void {
	actual = (''+actual)
	if (actual.indexOf(expected) < 0) throw new AssertError(`contains failed ${msg ? ": "+msg : ""}`, actual, `something containing '${expected}'`, true)
}

export function getBody(): string {
	return document.body.toString().replace(/^body{(.*)}$/,'$1').replace(/^body\b/,'')
}

export function assertBody(expected: string): void {
	let actual = getBody();
	if (actual !== expected) throw new Error(`assertBody failed\nActual:   ${actual}\nExpected: ${expected}`)
}

/** Get the full CSS content from the :root style tag in head */
export function getCss(): string {
	let css = '';
	for(const el of document.head.childNodes) {
		if (el instanceof Element && el.tagName === 'style') {
			css += el.textContent + "\n";
		}
	}
	return css;
}

export function assertCss(...expected: string[]) {
	const found = getCss().split("\n").map(s => s.trim()).filter(s => s);
	expect(found).toEqual(expected);
}


export async function assertThrow(what: string, func: ()=>void): Promise<void>;
export async function assertThrow(func: ()=>void): Promise<void>;

export async function assertThrow(a: any, b?: any): Promise<void> {
	if (typeof a == 'function') {
		b = a
		a = undefined
	}
	try {
		await b()
	} catch(e) {
        const s = ''+e
		if (a && s.indexOf(a)<0) throw new AssertError(`wrong exception`, s, `something containing "${a}"`, true)
		return
	}
	throw new AssertError(`exception expected`, undefined, `something containing "${a}"`, true)
}

export const passTime = fakedom.passTime

export function assertDomUpdates(expected: {new?: number, changed?: number, moved?: number}) {
	const counts = fakedom.getCounts()
	if (expected.new!=null) expect(counts.new).toEqual(expected.new)
	if (expected.changed!=null) expect(counts.changed).toEqual(expected.changed)
	if (expected.moved!=null) expect(counts.moved).toEqual(expected.moved)
}

export async function reset() {
	fakedom.mockAnimations();
	A.copy(A.cssVars, {});
	A.unmountAll();
	try {
		await fakedom.passTime(3001); // wait for deletion transitions
		assertBody(``);
	} finally {
		// Force-clear DOM and state even if errors occurred
		fakedom.clearBody();
	}
	fakedom.resetCounts();
	A.setErrorHandler();
}
